import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LogoutIcon from "@mui/icons-material/Logout";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Button,
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Box, Paper } from "@mui/material/";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { useEffect, useState } from "react";
import Algo8HomeLogo from "../../assets/Algo8HomeLogo.png";
import homeBg from "../../assets/homeBg.png";
import homeLogo from "../../assets/homeLogo.png";
import watermark from "../../assets/watermark.png";
import DateRangeFilter from "../../components/Common/DateRangeFilter";
import { useAuthContext } from "../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import ProductionChart from "../quality/Components/ProductionChart";
import SavingGraph from "./Components/SavingGraph";
import ToolAccuracyGraph from "./Components/ToolAccuracyGraph";
import useApi from "../../service/api.service";
import CustomSkeleton from "../../components/Common/CustomSkeleton";
import { customDateConvert } from "../../components/Common/Utils/Utils";
import * as XLSX from "xlsx";
import toast, { Toaster } from "react-hot-toast";
import CustomHead from "../../components/Common/CustomHead";

const styles = {
  allTabStyle: {
    fontSize: "12px",
    // border: "1px solid #D4D4D4",
    borderRadius: "25px",
    marginRight: "10px",
  },
};
const chartPaperStyle = {
  // flex: 1,
  borderRadius: "20px",
  height: "250px",
  // boxShadow: "0px 3px 6px #0000001F",
  boxShadow: "none",
  border: "1px solid #3EC2F0",
  backgroundColor: "#1C3169",
  boxSizing: "border-box",
  padding: "5px",
};
const layoutBoxStyle = {
  width: "97%",
  mx: "auto",
  display: "flex",
  gap: "20px",
  marginBottom: "20px",
};
const mainDivStyle = {
  width: "100%",
  height: "100vh",
  backgroundImage: `url(${homeBg})`,
  backgroundSize: "100% 100%",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center",
};
const secondDivStyle = {
  width: "100%",
  height: "100%",
  fontSize: "14px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
};
const thirdDivStyle = {
  width: "100%",
  padding: "20px",
  position: "fixed",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
const mainBoxStyle = {
  width: "315px",
  height: "275px",
};
const openIconStyle1 = {
  color: "#9F9F9F",
  cursor: "pointer",
  ml: 1,
  "&:hover": {
    color: "#3984BD",
  },
};
const openIconStyle2 = {
  color: "#9F9F9F",
  cursor: "pointer",
  ml: 1,
  "&:hover": {
    color: "#A45921",
  },
};
const textStyle = {
  fontSize: "12px",
  marginRight: "10px",
  fontWeight: "500",
};
const boxDivStyle = {
  display: "flex",
  fontSize: "10px",
  color: "#A5ABAD",
};
const boxStyle1 = {
  border: "2px solid #315E9C",
  display: "flex",
  width: "50%",
  flexDirection: "column",
  gap: "5px",
  padding: "10px",
  borderRadius: "10px",
  marginRight: "8px",
  backgroundColor: "#2C1E68",
};
const boxStyle2 = {
  border: "2px solid #803F31",
  display: "flex",
  width: "50%",
  flexDirection: "column",
  gap: "5px",
  padding: "10px",
  borderRadius: "10px",
  marginLeft: "8px",
  backgroundColor: "#411350",
};
const allTabStyle = {
  width: "30%",
  fontSize: "10px",
  padding: "2px 0px 0px",
  border: "1px solid #3FC1F0",
  borderRadius: "25px",
  margin: "2%",
};
const pTagStyle = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
};
const spanStyle = {
  width: "12px",
  height: "12px",
  backgroundColor: "#34A853",
  borderRadius: "2px",
};
const pDivStyle = {
  display: "flex",
  justifyContent: "space-between",
};
const paperStyle = {
  position: "absolute",
  top: 60,
  right: 20,
  width: "150px",
  display: "flex",
  flexDirection: "column",
  zIndex: 999,
  backgroundColor: "white",
  margin: "auto",
  padding: "4px 12px",
  justifyContent: "space-between",
  boxShadow: "0px 3px 6px #0000001F",
};
const boxStyle = {
  fontSize: "15px",
  p: 1,
  "&:hover": { backgroundColor: "rgba(253, 87, 7, 0.1)" },
  cursor: "pointer",
  color: "#404040",
};
const iconStyle2 = {
  mb: -0.5,
  width: "20px",
  height: "20px",
  color: "#404040",
};

export default function CenteredTabs() {
  const navigate = useNavigate();
  const { logout, authState } = useAuthContext();
  const [isDropdownVisible, setDropdownVisible] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [pieData, setPieData] = useState(null);
  const [accuracyData, setAccuracyData] = useState(null);
  const [savingsData, setSavingsData] = useState(null);
  const [downloadSavingsData, setDownloadSavingsData] = useState(null);
  const [downloadAccuracyData, setDownloadAccuracyData] = useState(null);
  const API = useApi();
  const [downloadAllow, setDownloadAllow] = useState(false);
  const [value, setValue] = useState(1);

  const handleBoxClick = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  useEffect(() => {
    const downloadData = savingsData?.dates?.map((date, index) => ({
      date: date,
      totalScrapCost: savingsData?.totalScrapCost[index],
    }));
    setDownloadSavingsData(downloadData);
  }, [savingsData]);
  useEffect(() => {
    const downloadData = accuracyData?.dates?.map((date, index) => ({
      date: date,
      scrapParts: accuracyData?.scrapParts[index],
      suspiciousParts: accuracyData?.suspiciousParts[index],
      actualGoodParts: accuracyData?.actualGoodParts[index],
    }));
    setDownloadAccuracyData(downloadData);
  }, [accuracyData]);

  const handleLogout = () => {
    logout();
  };

  const paperRef = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (paperRef.current && !paperRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [toggleDateFilter, setToggleDateFilter] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);
  const [finalDate, setFinalDate] = useState({
    startDate: null,
    endDate: null,
  });

  const fetchData = async () => {
    const customParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };

    try {
      setLoading1(true);
      const results = await Promise.allSettled([
        // API.getPartsCount(customParams),
        API.getAccuracyData(customParams),
        API.getSavingsData(customParams),
      ]);
      const [
        // partsCountResponse,
        accuracyDataResponse,
        savingsDataResponse,
      ] = results.map((result) =>
        result.status === "fulfilled" ? result.value : null
      );
      setLoading1(false);
      // setPieData(partsCountResponse.data[0]);
      setAccuracyData(accuracyDataResponse.data);
      setSavingsData(savingsDataResponse.data);
    } catch (error) {
      setLoading1(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [finalDate]);

  const handleDownload = () => {
    const wb = XLSX.utils.book_new();

    // const partsCountData = Array.isArray(pieData) ? pieData : [pieData];
    // const modifiedPartsData = partsCountData.map((entry) => {
    //   const { Total_Parts, Good_Parts, Suspicious_Parts, ...rest } = entry;
    //   return {
    //     ...rest,
    //     "Total Parts": Total_Parts,
    //     "Good Parts": Good_Parts,
    //     "Suspicious Parts": Suspicious_Parts,
    //   };
    // });
    // const partsCountSheet = XLSX.utils.json_to_sheet(modifiedPartsData);
    // setColumnWidths(partsCountSheet, modifiedPartsData);
    console.log("downloadAccuracyData", downloadAccuracyData);

    const modifiedAccuracyData = downloadAccuracyData.map((entry) => {
      const { actualGoodParts, scrapParts, suspiciousParts, date, ...rest } =
        entry;
      return {
        ...rest,
        Date: date,
        "Good Parts": actualGoodParts,
        "Scrap Parts": scrapParts,
        "Suspicious Parts": suspiciousParts,
      };
    });
    const accuracyDataSheet = XLSX.utils.json_to_sheet(modifiedAccuracyData);
    setColumnWidths(accuracyDataSheet, modifiedAccuracyData);

    const modifiedSavingsData = downloadSavingsData.map((entry) => {
      const { totalScrapCost, date, ...rest } = entry;
      return {
        ...rest,
        Date: date,
        "Total Savings (in '000s USD)": totalScrapCost,
      };
    });
    const savingsDataSheet = XLSX.utils.json_to_sheet(modifiedSavingsData);
    setColumnWidths(savingsDataSheet, modifiedSavingsData);

    // XLSX.utils.book_append_sheet(wb, partsCountSheet, "ProductionSummary");
    XLSX.utils.book_append_sheet(wb, accuracyDataSheet, "AccuracyData");
    XLSX.utils.book_append_sheet(wb, savingsDataSheet, "TotalSavings");

    const oneDay = 24 * 60 * 60 * 1000;
    const oneWeek = 7 * oneDay;
    const defaultStartDate = new Date(Date.now() - oneWeek);
    const defaultEndDate = new Date(Date.now() - oneDay);
    const startDate = finalDate.startDate
      ? new Date(finalDate.startDate)
      : defaultStartDate;
    const endDate = finalDate.endDate
      ? new Date(finalDate.endDate)
      : defaultEndDate;

    XLSX.writeFile(
      wb,
      `Production Summary From ${customDateConvert(
        startDate,
        "MM-DD-YYYY"
      )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.xlsx`
    );
    toast.success("Data downloaded successfully");
  };

  const setColumnWidths = (worksheet, data) => {
    const columnHeaders = Object.keys(data[0]);
    const columnWidths = columnHeaders.map((header) => {
      const headerLength = header.length;
      const maxLength = data.reduce((max, row) => {
        const valueLength = row[header] ? row[header].toString().length : 0;
        return Math.max(max, valueLength);
      }, headerLength);
      return { wch: maxLength };
    });
    worksheet["!cols"] = columnWidths;
  };

  useEffect(() => {
    if (downloadAllow) {
      handleDownload();
      setDownloadAllow(false);
    }
  }, [downloadAllow]);

  const onRefinaryClick = () => {
    navigate("/plant");
  };

  return (
    <div style={mainDivStyle}>
      <div style={thirdDivStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
          <img src={watermark} alt="header" width="25px" height="25px" />
          <img src={Algo8HomeLogo} alt="header" width="150px" height="25px" />
        </div>
        <div
          style={{
            color: "white",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={onRefinaryClick}
        >
          {authState?.selectedRefinary}
          {/* IAC COTTONDALE */}
        </div>
        <div style={{ ...pTagStyle, gap: "15px" }}>
          <Button
            variant="contained"
            size="small"
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "32px",
              fontSize: "12px",
              boxShadow: "none",
              backgroundColor: "white",
              color: "#087BB8",
              borderRadius: "25px",
              marginRight: "15px",
              fontWeight: "600",
              "&:hover": {
                backgroundColor: "#fff",
                boxShadow: "none",
              },
            }}
            onClick={() => {
              navigate("/live-production");
            }}
          >
            Go to Dashboard
          </Button>
          <img src={homeLogo} alt="header" width="145px" height="25px" />
          <Box
            sx={{
              "&:hover": { color: "#FD5707" },
              cursor: "pointer",
              color: "#FFFFFF",
            }}
            onClick={handleBoxClick}
          >
            <AccountCircleIcon sx={{ fontSize: "30px" }} />
            <KeyboardArrowDownIcon
              sx={{ fontSize: "25px", ml: "-1px", mb: "2px" }}
            />
          </Box>
        </div>
        {isDropdownVisible && (
          <Paper ref={paperRef} sx={paperStyle}>
            <Box sx={boxStyle} onClick={handleLogout}>
              <LogoutIcon sx={iconStyle2} /> Sign Out
            </Box>
          </Paper>
        )}
      </div>
      <div style={secondDivStyle}>
        {/* <Box sx={mainBoxStyle}>
          <Tabs
            value={value}
            onChange={handleChange}
            centered
            sx={{
              "& .MuiTab-root": {
                minHeight: "30px",
                color: "#A5ABAD",
              },
              "& .MuiTabs-indicator": {
                height: "0px",
              },
              "& .Mui-selected": {
                backgroundColor: "#3FC1F0",
                color: "#fff",
                borderRadius: "25px",
              },
              "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                color: "#fff",
              },
              marginBottom: "5px",
            }}
          >
            <Tab style={allTabStyle} label="Today" />
            <Tab style={allTabStyle} label="Last 7 Days" />
            <Tab style={allTabStyle} label="Last 30 Days" />
          </Tabs>
          <div style={boxDivStyle}>
            <Box sx={boxStyle1}>
              <Typography sx={textStyle}>
                Parts Produced
                <Link to="/quality">
                  <OpenInNewIcon fontSize="small" sx={openIconStyle1} />
                </Link>
              </Typography>
              <div style={pDivStyle}>
                <p style={pTagStyle}>
                  <span style={spanStyle}></span>Good Parts
                </p>
                {data.partsProduced.good}
              </div>
              <div style={pDivStyle}>
                <p style={pTagStyle}>
                  <span
                    style={{ ...spanStyle, backgroundColor: "#EA4335" }}
                  ></span>
                  Scrap Parts
                </p>
                {data.partsProduced.scrap}
              </div>
            </Box>
            <Box sx={boxStyle2}>
              <Typography sx={textStyle}>
                Live AI Predictions
                <Link to="/live-production">
                  <OpenInNewIcon fontSize="small" sx={openIconStyle2} />
                </Link>
              </Typography>
              <div style={pDivStyle}>
                <p style={pTagStyle}>
                  <span
                    style={{ ...spanStyle, backgroundColor: "#EA8600" }}
                  ></span>
                  Suspicious Parts
                </p>
                {data.LiveAiPrediction.suspicious}
              </div>
            </Box>
          </div>
        </Box> */}
        <CustomHead
          title={"Scorecard - Quality Prediction"}
          dateRange={dateRange}
          setDateRange={setDateRange}
          value={value}
          setValue={setValue}
          finalDate={finalDate}
          setFinalDate={setFinalDate}
          page={"home"}
          downloadPermission={true}
          setDownloadAllow={setDownloadAllow}
        />
        <Toaster />
        <Box sx={layoutBoxStyle}>
          {/* {loading1 ? (
            <CustomSkeleton type="" height="250px" />
          ) : (
            <Paper sx={chartPaperStyle}>
              <ProductionChart
                page={"home"}
                totalParts={pieData?.Total_Parts}
                goodParts={pieData?.Good_Parts}
                // scrapParts={pieData?.Suspicious_Parts}
                suspiciousParts={pieData?.Suspicious_Parts}
              />
            </Paper>
          )} */}
          {loading1 ? (
            <CustomSkeleton type="" width="66%" height="250px" />
          ) : (
            <Paper
              sx={{
                ...chartPaperStyle,
                backgroundColor: "#212A69",
                width: "66%",
              }}
            >
              <ToolAccuracyGraph
                suspicious={accuracyData?.suspiciousParts}
                scrap={accuracyData?.scrapParts}
                good={accuracyData?.actualGoodParts}
                categories={accuracyData?.dates}
              />
            </Paper>
          )}
          {loading1 ? (
            <CustomSkeleton type="" width="33%" height="250px" />
          ) : (
            <Paper
              sx={{
                ...chartPaperStyle,
                backgroundColor: "#212A69",
                width: "33%",
              }}
            >
              <SavingGraph
                good={savingsData?.totalScrapCost}
                categories={savingsData?.dates}
              />
            </Paper>
          )}
        </Box>
      </div>
    </div>
  );
}
